import { blackColor, whiteColor } from 'src/tools/constant';
import { randomNumber } from 'src/tools/helper';
import { ESocialMediaType } from 'src/types/common/SalesChannel';

export enum EnumCollapseId {
  footerStyle = 'saleChannelContentFooterFooterStyle',
  locationSelector = 'saleChannelContentFooterLocationSelector',
  languageSelector = 'saleChannelContentFooterLanguageSelector',
  currencySelector = 'saleChannelContentFooterCurrencySelector',
  socialMedia = 'saleChannelContentFooterSocialMedia',
  footerMenu = 'saleChannelContentFooterFooterMenu',
  footerNote = 'saleChannelContentFooterFooterNote',
}

export enum EType {
  QR_CODE = 'QR_CODE',
  URL_LINK = 'URL_LINK',
}

export enum EFooterMenuType {
  TextLink = 'TextLink',
  NavigationGroup = 'NavigationGroup',
  LocationSelector = 'LocationSelector',
  LanguageSelector = 'LanguageSelector',
  CurrencySelector = 'CurrencySelector',
  SocialMedia = 'SocialMedia',
}

export const fixedCollapse = [
  EnumCollapseId.footerMenu,
  EnumCollapseId.locationSelector,
  EnumCollapseId.languageSelector,
  EnumCollapseId.currencySelector,
  EnumCollapseId.socialMedia,
  EnumCollapseId.footerStyle,
  EnumCollapseId.footerNote,
];

const generateFooterStyle = () => ({
  backgroundColor: blackColor,
  textAndIconColor: whiteColor,
  dividerColor: whiteColor,
  displayPaymentMethodLogo: true,
});

const generateFooterLocationOption = () => {
  return {
    title: '',
    linkLibrary: null,
    draggableId: randomNumber(),
  };
};

const generateFooterLocationSelector = () => {
  return {
    title: '',
    locationOptions: [],
  };
};

const generateFooterLanguageSelector = () => {
  return {
    title: '',
  };
};

const generateFooterCurrencySelector = () => {
  return {
    title: '',
    menuItemType: EFooterMenuType.CurrencySelector,
  };
};

const generateNewSocialMediaOption = () => {
  return {
    draggableId: randomNumber(),
    mediaType: ESocialMediaType.Wechat,
    icon: null,
    refType: EType.URL_LINK,
  };
};

const generateFooterSocialMedia = () => {
  return {
    title: '关注我们',
    socialMediaList: [],
  };
};

const generateFooterMenuNewOption = () => {
  return {
    menuItemType: EFooterMenuType.TextLink,
    draggableId: randomNumber(),
    link: null,
    title: '',
  };
};

const generateFooterFooterMenu = () => {
  return {
    footerMenuColumn1: [],
    footerMenuColumn2: [],
    footerMenuColumn3: [],
    footerMenuColumn4: [],
    footerMenuColumn5: [],
  };
};

// const generateFooterFooterNotes = () => {
//   return { footerNotes: '' };
// };

export {
  generateFooterStyle,
  generateFooterLocationSelector,
  generateFooterLanguageSelector,
  generateFooterCurrencySelector,
  generateFooterSocialMedia,
  // generateFooterFooterNotes,
  generateFooterFooterMenu,
  generateFooterLocationOption,
  generateNewSocialMediaOption,
  generateFooterMenuNewOption,
};
